<template>
	<div class="calculated form-group" :class="{ 'is-empty': empty }" :data-element="element.id" v-show="!hidden">
		<div class="d-flex justify-content-between align-items-center">
			<label class="element-label" :class="classes('title')" :title="required ? trans('buttons.required') : ''">
				<span v-html="macro(label)"></span>
				<small v-if="required" class="required">*</small>
			</label>
			<div v-if="fieldVisibleOnlyInPreview" class="app--engagement-advisor-preview-icon ms-2">
				<app-icon :title="trans('visibility.field.preview')" value="eye" type="fas" class="fa-sm" />
			</div>
		</div>
		<div class="input-group app--cursor-help" ref="field">
			<div v-if="type == 'CURRENCY'" class="input-group-text" :class="classes('calculated')" :title="currency">
				{{ symbol }}
			</div>
			<div class="form-control" :class="classes('calculated') + (numeric ? ' text-right' : '')">
				{{ value }}<span v-if="printing || !value">&nbsp;</span>
			</div>
		</div>
		<div class="invalid-feedback" :for="label"></div>
		<small class="form-text" :class="classes('description')">
			<span v-if="description" v-html="macro(description)"></span>&nbsp;
		</small>
		<div ref="popover" class="app--popup popper" role="tooltip" width="200">
			<div class="p-content">
				<div class="header">{{ $t('app.common.calculated') }}</div>
			</div>
			<div class="p-arrow" data-popper-arrow></div>
		</div>
	</div>
</template>

<script>
import { createPopper } from '@popperjs/core'
import store from '../../store'

export default {
	props: {
		definition: { type: Object, required: true },
		element: { type: Object, required: true },
	},
	data() {
		return { popover: null }
	},
	computed: {
		currency() {
			return this.type == 'CURRENCY' ? store.getters.currency : null
		},
		description() {
			return typeof this.definition.description == 'string' ? this.definition.description : null
		},
		empty() {
			return this.value == ''
		},
		formatter() {
			return store.getters.formatterNumeric(this.precision)
		},
		hidden() {
			return this.options('hidden') == true
		},
		label() {
			return this.definition.title
		},
		numeric() {
			return this.type == 'TEXT' || this.type == 'BOOLEAN' ? false : true
		},
		precision() {
			return this.options('precision') > 0 ? this.options('precision') : 0
		},
		printing() {
			return store.state.printing
		},
		readonly() {
			return store.getters.readonly(this.definition, !this.empty)
		},
		required() {
			return this.options('required') == true
		},
		symbol() {
			return store.getters.currencysymbol(this.currency)
		},
		type() {
			return this.options('type')
		},
		valid() {
			return !(this.element && this.element.valid === false)
		},
		value() {
			return this.numeric && this.element.value ? this.format(this.element.value) : this.element.value
		},
		fieldVisibleOnlyInPreview() {
			return this.definition.print_visibility == 'preview' && store.state.preview == true && store.state.complete == false
		}
	},
	mounted() {
		this.popover = createPopper(this.$refs.field, this.$refs.popover, {
			placement: 'top',
			modifiers: [
				{ name: 'flip', options: { fallbackPlacements: ['top', 'bottom'] } },
				{ name: 'offset', options: { offset: [0, 8] } },
				{ name: 'arrow', options: { padding: 5 } },
			]
		})
	},
	methods: {
		classes(index) {
			return store.getters['classes'](index)
		},
		format(value) {
			try {
				value = this.formatter.format(value)
			} catch (e) {
				value = ''
			}
			return value
		},
		macro(value) {
			return store.getters['macro'](value)
		},
		options(value) {
			return store.getters['options'](this.definition, value)
		},
		trans(key) {
			let trans = store.getters.trans(key)
			return trans ? trans : this.$t('front.' + key)
		}
	}
}
</script>
